import { render, staticRenderFns } from "./InterTableButton.vue?vue&type=template&id=518d2dd4&scoped=true"
import script from "./InterTableButton.vue?vue&type=script&lang=js"
export * from "./InterTableButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d2dd4",
  null
  
)

export default component.exports